export const TwitchIcon = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_188_26821)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#1E0D37"
      />
      <path
        d="M34.7142 26L24 36.7142V75.2858H36.8583V86L47.5725 75.2858H56.1425L75.43 55.9984V26H34.7142ZM71.1449 53.8575L62.5717 62.4275H54.0016L46.5004 69.9287V62.4275H36.8583V30.285H71.1449V53.8575Z"
        fill="#9147FF"
      />
      <path
        d="M64.7158 37.7862H60.4308V50.6445H64.7158V37.7862Z"
        fill="#9147FF"
      />
      <path
        d="M52.9295 37.7862H48.6445V50.6445H52.9295V37.7862Z"
        fill="#9147FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_26821">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
